var map = {
	"./agree.svg": "b081",
	"./okay.svg": "05d6",
	"./plus.svg": "9a9c",
	"./refresh.svg": "8c01",
	"./shield.svg": "3ca3",
	"./time.svg": "d8eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b582";